import React from "react";
import Skeleton from "react-loading-skeleton";
import "./Challenges.css";

const ChallengeSkeleton = () => {
  return (
    <div className="challenges-wrapper">
      <div className="challenges-top">
        <div className="challenges-tleft">
          <div className="challenge-container">
            <Skeleton height={330} width={350} borderRadius={16} />
            <Skeleton height={20} width={200} style={{ marginTop: 10 }} />

            {/* avatars row */}
            <div style={{ display: "flex", gap: "8px", marginTop: 10 }}>
              <Skeleton circle width={30} height={30} />
              <Skeleton circle width={30} height={30} />
              <Skeleton circle width={30} height={30} />
              <Skeleton width={40} height={25} borderRadius={10} />
            </div>
          </div>
        </div>

        <div className="challenges-tright">
          <Skeleton height={25} width={250} />

          <div style={{ marginTop: 20 }}>
            <Skeleton height={15} width={`90%`} />
          </div>
          <div style={{ marginTop: 15 }}>
            <Skeleton height={15} width={`80%`} />
          </div>
          <div style={{ marginTop: 15 }}>
            <Skeleton height={15} width={`70%`} />
          </div>

          <div style={{ marginTop: 25 }}>
            <Skeleton height={45} width={`60%`} borderRadius={25} />
          </div>
        </div>
      </div>

      {/* Bottom section */}
      <div className="challenges-bottom" style={{ marginTop: 30 }}>
        <Skeleton height={150} borderRadius={12} />
      </div>
    </div>
  );
};

export default ChallengeSkeleton;